import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaShoppingBag, FaInstagram } from "react-icons/fa";
import CartModal from "./CartModal";

const NavBar = () => {  
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [showLogo, setShowLogo] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const cartItems = useSelector(state => state.cart.items);
  const itemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY < 110;
      setShowLogo(show);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="flex flex-col fixed top-0 left-0 right-0 z-50 bg-base-100">
      <div className={`navbar bg-base-100 text-base-content shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] transition-all duration-300 ${showLogo ? 'h-36' : 'h-16'}`}>
        {showLogo && (
          <div className="md:block absolute left-1/2 transform -translate-x-1/2">
            <Link to="/">
            <img 
              src="/pageElements/logo_M_01.png" 
              alt="Logo" 
              className="h-36 w-36"
            />
            </Link>
          </div>
        )}
        {!showLogo && (
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <Link to="/" className="text-2xl custom-font-text">
              CIRCE'S FORGE
            </Link>
          </div>
        )}
        
        <div className="navbar-start">
          <div className={`pl-10 hidden md:flex space-x-8 ${showLogo ? 'pt-24' : 'pt-0'}`}>
          <Link
              to={`/`}
              className="items-center justify-between hover:underline underline-offset-4 text-xl"
            >
              HOME
            </Link>
          <Link
              to={`/shop`}
              className="items-center justify-between hover:underline underline-offset-4 text-xl"
            >
              SHOP
            </Link>
            <Link
              to={`/about`}

              className="items-center justify-between hover:underline underline-offset-4 text-xl"
            >
              ABOUT
            </Link>

            <Link
              to={`/contact`}
              className="items-center justify-between hover:underline underline-offset-4 text-xl"
            >
              CONTACT
            </Link>

          </div>
          
          <div className={`dropdown dropdown-start md:hidden ${showLogo ? 'pt-24' : 'pt-0'}`}>
            <label 
              tabIndex={0} 
              className="btn btn-ghost btn-circle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              Menu
            </label>
            <ul
              tabIndex={0}
              className={`menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52 ${isMenuOpen ? '' : 'hidden'}`}
            >
              <li><Link to="/" className="py-2 hover:underline" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li><Link to="/shop" className="py-2 hover:underline" onClick={() => setIsMenuOpen(false)}>Shop</Link></li>
              <li><Link to="/about" className="py-2 hover:underline" onClick={() => setIsMenuOpen(false)}>About</Link></li>
              <li><Link to="/contact" className="py-2 hover:underline" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
            </ul>
          </div>
        </div>
        

        <div className={`navbar-end ${showLogo ? 'pt-24' : 'pt-0'}`}>
          <div className="flex flex-row items-center">
          <a href="https://www.instagram.com/circesforge/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={24} />
          </a>
          <button 
            onClick={() => setIsCartOpen(true)}
            className="btn btn-ghost relative"
          >
            <FaShoppingBag size={24} />
            {itemCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#D4AF37] text-white rounded-full w-5 h-5 text-xs flex items-center justify-center ">
                {itemCount}
              </span>
            )}
          </button>
          </div>
          
        </div>
        <CartModal isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      </div>
    </div>
  )
}
export default NavBar


